import { createFileRoute } from '@tanstack/react-router';
import type { JSX } from 'react';

import { DataIntegrationPage } from '@/areas/data-integrations/DataIntegrations/DataIntegrationPage';
import { canViewDataIntegrationsSettings } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';

export const Route = createFileRoute('/_authenticated/settings/_menu/organization/data-integrations')({
    staticData: { access: { permissions: canViewDataIntegrationsSettings }, chrome: 'home' } satisfies PageStaticData,
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    return <DataIntegrationPage />;
}
